<img [src]="image" class="img-fluid" (load)="imagemCarregadaStatus()" hidden />

<div class="container-fluid">
  <div class="row">
    <div class="col-xl-12 order-xl-1">
      <div *ngIf="!imagemCarregada">Carregando imagem...</div>
      <img [src]="image" class="img-fluid" *ngIf="imagemCarregada" />
    </div>
  </div>
</div>
